/* tslint:disable */
import { loadStyles } from '@microsoft/load-themed-styles';

const styles = {
  dummy: 'dummy_b52be01b',
};

export = styles;

loadStyles([{"rawString":".dummy_b52be01b{background:#00f}"}]);
/* tslint:enable */